export default __webpack_public_path__ + "static/look-1d3726923ae10d1fa90227a6c558e31e.png";